const dfPhotosVideos = {
  introHead: 'Organisez vos fichiers',
  introDescription:
    'Nous vous aidons à organiser et à stocker en toute sécurité les photos et vidéos importantes.',
};

export default dfPhotosVideos;
